import { Typography, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'react-layout-components';
import { withRouter } from 'react-router-dom';
import Container from './Container';


class Footer extends React.PureComponent {

    render() {

        const { classes } = this.props

        return (
            <Box className={classes.root}>
                <Container>
                    <Box center width="100%">
                        <Typography className={classes.footerText}>Cytech 2018</Typography>
                    </Box>
                </Container>
            </Box>
        )
    }

}

Footer.propTypes = {
    classes: PropTypes.any,
    light: PropTypes.bool,
    elevated: PropTypes.bool
}

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.primary.dark,
        height: 64,
        [theme.breakpoints.down('xs')]: {
            height: 56 * 2,
            paddingBottom: 56
        },
    },
    footerText: {
        color: '#FFFFFF',
        fontWeight: '700'
    }
})

export default withRouter(withStyles(styles)(Footer))


// WEBPACK FOOTER //
// ./src/components/common/Footer.js